import { render, staticRenderFns } from "./MonthlyPriceComponentsChart.vue?vue&type=template&id=07c71928&scoped=true&"
import script from "./MonthlyPriceComponentsChart.vue?vue&type=script&lang=js&"
export * from "./MonthlyPriceComponentsChart.vue?vue&type=script&lang=js&"
import style0 from "./MonthlyPriceComponentsChart.vue?vue&type=style&index=0&id=07c71928&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c71928",
  null
  
)

export default component.exports